import { gql } from '@apollo/client';

const checkPointFieldsFragment = gql`
  fragment CheckPointFields on CheckPoint {
    Id
    ReporterName
    DataCollectionDate
    DataCollectedDuringAppraisal
    IsDraft
    CheckpointDocuments {
      Id
      DocumentType
      FileName
      CheckpointReappraisalRationaleReview {
        Id
        Status
      }
    }
    CheckpointPerformanceItems {
      Id
      AddedInCurrentCheckpoint
      IsDeletable
      OrgUnitId
      MeasurementName
      MeasurementDescription
      MeasurementCalculation
      MeasurementUnit
      Numerator
      Denominator
      TargetDescription
      GoodPerformanceIndicator
      TimeBounds
      TimeFrame
      CaptureFrequency
      ReportFrequency
      MeasurementLevel
      MeasurementUse
      LimitationsOrBlindSpots
      QualityDomain
      CustomQualityDomainDefinition
      BusinessObjective
      QualityObjective
      ParentCheckpointPerformanceItemId
      DataPoint {
        Id
        Status
        LowerLimit
        UpperLimit
        Actual
        Notes
      }
      ParentCheckpointPerformanceItem {
        DataPoint {
          Status
          LowerLimit
          UpperLimit
          Actual
          Notes
        }
      }
    }
  }
`;

export default checkPointFieldsFragment;
